import { getRequest, postRequest } from '../../../utils/axios'

export const fetchAuthenticatedUser = () => {
  const url = `/v2/users/me`

  return getRequest(url)
}

export const fetchClub = (clubUuid) => {
  const url = `v2/clubs/${clubUuid}`

  return getRequest(url)
}

export const createStripeSubscription = (clubUuid, data) => {
  const url = `v2/clubs/${clubUuid}/subscription/create`

  return postRequest(url, data)
}

export const createStripeCheckoutSession = (clubUuid, data) => {
  const url = `v2/clubs/${clubUuid}/subscription/create-checkout-session`

  return postRequest(url, data)
}

export const createStripeCancelSession = (subscriptionUuid, data) => {
  const url = `v2/stripe/${subscriptionUuid}/create-cancel-session`

  return postRequest(url, data)
}

export const renewStripeSubscription = (subscriptionUuid) => {
  const url = `v2/stripe/${subscriptionUuid}/renew`

  return postRequest(url)
}

export const createStripeUpdateSession = (subscriptionUuid, data) => {
  const url = `v2/stripe/${subscriptionUuid}/create-update-session`

  return postRequest(url, data)
}

export const cancelPayPalSubscription = (clubUuid) => {
  const url = `v2/clubs/${clubUuid}/subscription/cancel-paypal-subscription`

  return postRequest(url)
}
